import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from '../shared/local-storage.service';
import { OperatorUser } from '../shared/operator-user.model';

@Component({
    selector: 'app-add-fishery-dialog',
    templateUrl: './add-fishery-dialog.component.html',
    styleUrls: ['./add-fishery-dialog.component.css'],
    standalone: false
})
export class AddFisheryDialogComponent {
  selectedOption!: string;

  selectError: boolean = false;
  user: OperatorUser = LocalStorageService.current_user;

  constructor(
    public dialogRef: MatDialogRef<AddFisheryDialogComponent>,
  ) {
    // Determine which radio button should be selected by default
    if (this.user.trawlFishery) {
      this.selectedOption = 'trawl';
    } else if (this.user.groundfishFishery && this.user.hmsFishery) {
      this.selectedOption = 'both';
    } else if (this.user.groundfishFishery) {
      this.selectedOption = 'groundfishNonTrawl';
    } else if (this.user.hmsFishery) {
      this.selectedOption = 'hms';
    } else {
      this.selectedOption = '';
    }
  }

  onBackClick(): void {
    this.dialogRef.close();
  }

  onConfirmClick(): void {
    // If nothing is selected, show error and exit.
    if (!this.selectedOption) {
      this.selectError = true;
      return;
    }

    // Clear the error if the user has selected something
    this.selectError = false;

    // Update user fishery booleans based on the selected radio button
    switch (this.selectedOption) {
      case 'groundfishNonTrawl':
        this.user.groundfishFishery = true;
        this.user.hmsFishery = false;
        this.user.trawlFishery = false;
        break;

      case 'hms':
        this.user.groundfishFishery = false;
        this.user.hmsFishery = true;
        this.user.trawlFishery = false;
        break;

      case 'both':
        this.user.groundfishFishery = true;
        this.user.hmsFishery = true;
        this.user.trawlFishery = false;
        break;

      case 'trawl':
        this.user.groundfishFishery = false;
        this.user.hmsFishery = false;
        this.user.trawlFishery = true;
        break;
    }

    LocalStorageService.updateUser(true, false);

    this.dialogRef.close(this.selectedOption);
  }
}
